import React, { useState, useId } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
type FaqItem = {
  question: string;
  answer: string;
};
type FaqAccordionProps = {
  items: FaqItem[];
};
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const idPrefix = useId();
  const shouldReduceMotion = useReducedMotion();
  return <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-1">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `${idPrefix}-panel-${index}`;
      const buttonId = `${idPrefix}-button-${index}`;
      return <div key={item.question} className="py-1" data-id="element-2">
            <h3 data-id="element-3">
              <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="group flex w-full items-center justify-between gap-5 py-5 text-left font-sans text-base font-medium text-[#f5eee6] outline-none transition-colors duration-200 hover:text-white focus-visible:ring-2 focus-visible:ring-[#e849d8] focus-visible:ring-offset-4 focus-visible:ring-offset-[#120b18]" data-id="element-4">
                <span data-id="element-5">{item.question}</span>
                <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-[#e849d8] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-6" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-7">
              {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={shouldReduceMotion ? false : {
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={shouldReduceMotion ? undefined : {
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.22, 1, 0.36, 1]
          }} className="overflow-hidden" data-id="element-8">
                  <p className="max-w-2xl pb-6 pr-8 font-sans text-sm leading-7 text-[#c8bdc9]" data-id="element-9">
                    {item.answer}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}